<iframe  width="100%" height="900"  [src]="urlSafe" frameborder="0" allowFullScreen="true"></iframe>
